import React from 'react'
import PropTypes from 'prop-types'
import sprite from 'media/sprite.svg'

const Sprite = ({ id, ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...props}>
      <use xlinkHref={`${sprite}#${id}`} />
    </svg>
  )
}

Sprite.propTypes = {
  id: PropTypes.string.isRequired,
}

export default Sprite
